export const DocsTab = () => (
  <section className="flex max-w-4xl flex-col gap-4">
    <h2 className="text-xl font-semibold">Super Enhancement</h2>
    <p>
      Open Super Enhancement from the more actions menu on a job details page. The action is visible to VS developers
      and is available once the job has a main transcript.
    </p>
    <p>
      The page loads the main transcript and audio. Click Run super enhancement to send the action and start an
      iterative proofreading run. Messages are disabled until the run finishes.
    </p>
    <p>
      The agent checks transcript wording and speaker attribution, can request additional audio recognition through ASR
      Proxy, and verifies proposed edits before applying them to a separate result. Each run uses a snapshot of the main
      transcript, up to four iterations, and a $5 job budget.
    </p>
    <p>
      When the run finishes, the player compares the result with its input snapshot. The chat shows the number of
      applied edits, reported cost, and stop reason. A completed run may stop at a budget limit without resolving all
      issues. Chat instructions and run results are saved with server timestamps in chronological order. Refreshing the
      page restores the history, stage settings, and latest run status. Results are saved once per run even when the
      page is closed.
    </p>
    <p>
      The main job transcript is preserved. Instructions accept Enable or Disable speaker correction, audio relistening,
      and edit verification. They also accept free-form editing instructions. Click an instruction to send it
      immediately and configure the next run, then click Run super enhancement. Detection, editing, safety checks, and
      saving results always run. Disabling edit verification removes independent model review.
    </p>
  </section>
);
